import { render, staticRenderFns } from "./OfferOnBoardDocument.vue?vue&type=template&id=6827eeb0"
import script from "./OfferOnBoardDocument.vue?vue&type=script&lang=js"
export * from "./OfferOnBoardDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports